<template>
    <div>
        <h5><small>{{$t('outlet_setting.security_config.header_perm')}}</small></h5>
        <form @submit.prevent="editSecuritySettings">
            <div v-for="pt in permissionType" :key="pt.permissionID" class="custom-control custom-switch mb-3">
                <input type="checkbox" class="custom-control-input" :id="'switch_'+ pt.permissionID" v-model="hasPermission[pt.permissionID]">
                <label class="custom-control-label" :for="'switch_'+ pt.permissionID">{{pt.permission}}</label>
            </div>
            <div class="text-left mb-3">
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'permission',
    props:{
        permission: { type: Array },
        permissionType: { type: Array }
    },
    data(){
        return{
            arrPermission: []
        }
    },
    computed:{
        hasPermission(){
            var ret = {};
            for(var i=0; i<this.permissionType.length; i++){
                for(var j=0; j<this.permission.length; j++){
                    if(this.permission[j].permissionID == this.permissionType[i].permissionID){
                        ret[this.permission[j].permissionID] = true;
                    }
                }
            }
            return ret
        }
    },
    methods:{
        editSecuritySettings(){
            for(var key in this.hasPermission){
                if(this.hasPermission[key] == true){
                    this.arrPermission.push({"permissionID": parseInt(key)})
                } 
            }
            this.$emit('submitEdit', {permission: this.arrPermission});
        }
    }
}
</script>

<style scoped>
.custom-control-input{
    cursor: pointer;
}
</style>